import {Flow} from 'flow-to-typescript-codemod';

import * as React from 'react';

import EmojiPicker, {Props as PickerProps} from './emoji-picker';

import css from './dialog.css';


export default function EmojiDialog({
  ...props
}: Flow.Diff<
  PickerProps,
  {
    classNames: Record<any, any>;
  }
>) {
  return (
    <div className={css.dialog}>
      <EmojiPicker {...props} classNames={css} />
    </div>
  );
}
